import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { TabOccurrencesComponent } from './tab-occurrences.component';

@NgModule({
  declarations: [
    TabOccurrencesComponent
  ],
  imports: [
    TranslateModule,
    MatIconModule,
    MatSortModule,
    MatTableModule,
    MatButtonModule,
    MatDividerModule,
    MatPaginatorModule,
    FuseSharedModule,
    MatProgressSpinnerModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [
    TabOccurrencesComponent
  ]
})
export class TabOccurrencesModule { }
